import React from 'react';
import { useParams } from 'react-router';
import { TransactionsView } from '../../../guardian-dashboard/components/TransactionsView';
import { familyCurrenciesApi } from '../../api/familyCurrencies';

export const TransactionsPage = () => {
  const { currencyId } = useParams();
  return (
    <TransactionsView
      currencyId={Number(currencyId)}
      api={familyCurrenciesApi}
      backHref="/wallet"
    />
  );
};

export default TransactionsPage;
